import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Contract} from "../../models/Contract"

export const contractFields: IntercateKeysMap<Contract, EntityField<Contract>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id ugovora",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    title: {
		name: "title", dataType: EntityFieldDataType._string, label: "Naziv ugovora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    description: {
		name: "description", dataType: EntityFieldDataType._string, label: "Opis ugovora",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    number: {
		name: "number", dataType: EntityFieldDataType._string, label: "Broj ugovora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    startDate: {
		name: "startDate", dataType: EntityFieldDataType._date, label: "Datum početka ugovora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    endDate: {
		name: "endDate", dataType: EntityFieldDataType._date, label: "Datum isteka ugovora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    customerId: {
		name: "customerId", dataType: EntityFieldDataType._reference, label: "Klijent",
        referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    uploads: {
        name: "uploads", dataType: EntityFieldDataType._reference, label: "Uploads",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Uploads
		},
		validator: { required: false },
		sortable: true,
		filterable: true
	},
}

const contractFieldsArray: Array<EntityField<Contract>> = [
	contractFields.title,
	contractFields.description,
    contractFields.number,
	contractFields.startDate,
    contractFields.endDate,
	contractFields.customerId,
]

export const contractFieldsDescriptor: EntityFieldsDescriptor<Contract> = {
	listFields: contractFieldsArray,
	createFormFields: contractFieldsArray,
	updateFormFields: contractFieldsArray
}
